import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceCondition_Interface } from 'src/app/Interface/DeviceCondition_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceConditionService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<DeviceCondition_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceCondition?token="+Token).pipe(
      map(data=>{
        return data as Array<DeviceCondition_Interface>
      })
    )
  }

  AddDeviceCondition(model: DeviceCondition_Interface,Token:String):Observable<DeviceCondition_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      tajil:model.tajil,
      takhir:model.takhir,
      brabar:model.brabar,
      day:model.day,
      username:Token,
    }


      return this.http.post(environment.BaseUrl + "Daro/DeviceCondition/Add",body,{headers}).pipe(
        map(data=>{
          return data as DeviceCondition_Interface
        })
      )

  }

}
